var path = 'app/login/components/header/loginHeader.html';
var html = "<div class=header> <img class=header_headerImage src=" + require("../../../../images/header-image.jpg") + "> <div class=header_bar> <img class=header_logo src=" + require("../../../../images/orca-logo.png") + "> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/main/assets/app/login/components/header/loginHeader.html
 ** module id = 226
 ** module chunks = 2
 **/